import { isLocale, type Locale } from "@/kernel/locale";

// The visitor's explicit language choice (DSH-016), written by the language
// switcher and by a ?lang= address, read by the proxy. Environment-neutral:
// the switcher sets it in the browser, the proxy in a redirect.
export const LOCALE_COOKIE = "iron-locale";

/** One year, as the choice is meant to be remembered. */
export const LOCALE_COOKIE_MAX_AGE = 31_536_000;

export function localeCookie(locale: Locale, secure: boolean): string {
  return `${LOCALE_COOKIE}=${locale}; Path=/; Max-Age=${LOCALE_COOKIE_MAX_AGE}; SameSite=Lax${secure ? "; Secure" : ""}`;
}

/** The saved choice in a Cookie header, or null when absent or not a supported locale. */
export function readLocaleCookie(cookieHeader: string | null | undefined): Locale | null {
  for (const part of (cookieHeader ?? "").split(";")) {
    const separator = part.indexOf("=");
    if (separator === -1 || part.slice(0, separator).trim() !== LOCALE_COOKIE) continue;
    const value = part.slice(separator + 1).trim();
    return isLocale(value) ? value : null;
  }
  return null;
}
